import { createQueryKeys } from '@lukemorales/query-key-factory';

export const coBrokeAccess = createQueryKeys('coBrokeAccess', {
  mine: null,
});
